import type { CountryCode } from '@module/apis/client-side/live/type';
import type { CentrifugeMessage } from '../messageTypes';

export interface ChatBlockCountryMessage {
  data: {
    type: 'ChatBlockCountry';
    message: {
      blockedLocales: CountryCode[];
      fromLocale: CountryCode;
    };
    created_at?: number;
  };
  offset: number;
  seq?: undefined;
  gen?: undefined;
}

export const isChatBlockCountryMessage = (item: CentrifugeMessage): item is ChatBlockCountryMessage => {
  return 'data' in item && item.data.type === 'ChatBlockCountry';
};
